// 模拟数据


// 卡片数据
export const cardInfo = [{
        title: '用户总览',
        content: '9999万访问人次'
    },
    {
        title: '商品总览',
        content: '9999万件商品'
    },
    {
        title: '销量总览',
        content: '9999万单完成交易'
    },
]

// 折线图数据

export const chartData = {
    columns: ['日期', '访问用户', '下单用户', '下单率'],
    rows: [{
            日期: '1/1',
            访问用户: 1393,
            下单用户: 1093,
            下单率: 0.32,
        },
        {
            日期: '1/2',
            访问用户: 3530,
            下单用户: 3230,
            下单率: 0.26,
        },
        {
            日期: '1/3',
            访问用户: 2923,
            下单用户: 2623,
            下单率: 0.76,
        },
        {
            日期: '1/4',
            访问用户: 1723,
            下单用户: 1423,
            下单率: 0.49,
        },
        {
            日期: '1/5',
            访问用户: 3792,
            下单用户: 3492,
            下单率: 0.323,
        },
        {
            日期: '1/6',
            访问用户: 4593,
            下单用户: 4293,
            下单率: 0.78,
        },
        {
            日期: '1/7',
            访问用户: 4323,
            下单用户: 3293,
            下单率: 0.78,
        },
        {
            日期: '1/8',
            访问用户: 5593,
            下单用户: 4293,
            下单率: 0.68,
        },
        {
            日期: '1/9',
            访问用户: 2493,
            下单用户: 1993,
            下单率: 0.86,
        },
        {
            日期: '1/10',
            访问用户: 3463,
            下单用户: 2364,
            下单率: 0.70,
        },
        {
            日期: '1/11',
            访问用户: 5631,
            下单用户: 4293,
            下单率: 0.68,
        },
        {
            日期: '1/12',
            访问用户: 7892,
            下单用户: 5231,
            下单率: 0.64,
        },
        {
            日期: '1/13',
            访问用户: 6732,
            下单用户: 4293,
            下单率: 0.58,
        },
        {
            日期: '1/14',
            访问用户: 4232,
            下单用户: 3193,
            下单率: 0.76,
        },
        {
            日期: '1/15',
            访问用户: 5732,
            下单用户: 4293,
            下单率: 0.78,
        },
        {
            日期: '1/16',
            访问用户: 7732,
            下单用户: 4293,
            下单率: 0.58,
        },
        {
            日期: '1/17',
            访问用户: 5732,
            下单用户: 5293,
            下单率: 0.88,
        },
        {
            日期: '1/18',
            访问用户: 4732,
            下单用户: 4293,
            下单率: 0.93,
        },
    ]
};